import { NgModule } from '@angular/core';
import { FormlyModule } from '@ngx-formly/core';
import {
  dateRangeValidatorMessage,
  decimalValidatorMessage,
  emailValidatorMessage,
  fileNameValidatorMessage,
  maxLengthValidatorMessage,
  maxSelectFileValidatorMessage,
  minSizeFileValidatorMessage,
  maxSizeFileValidatorMessage,
  maxValidatorMessage,
  minLengthValidatorMessage,
  minValidatorMessage,
  nameValidatorMessage,
  nricValidatorMessage,
  percentageMessage,
  rangeMessage,
  requiredTrueValidatorMessage,
  requiredValidatorMessage,
  tinValidatorMessage,
  uenValidatorMessage,
  uniqueNricInArrayValidatorMessage,
} from './message';
import {
  dateRangeValidator,
  decimalValidator,
  emailValidator,
  fileNameValidator,
  maxSelectFileValidator,
  maxSizeFileValidator,
  minSizeFileValidator,
  nameValidator,
  nricValidator,
  percentageValidator,
  rangeValidator,
  requiredFileValidator,
  requiredSelectedValidator,
  requiredTrueValidator,
  tinValidator,
  uenValidator,
  uniqueNricInArrayValidator,
} from './validator';

@NgModule({
  imports: [
    FormlyModule.forChild({
      validationMessages: [
        { name: 'decimal', message: decimalValidatorMessage },
        { name: 'email', message: emailValidatorMessage },
        { name: 'fileName', message: fileNameValidatorMessage },
        { name: 'max', message: maxValidatorMessage },
        { name: 'maxLength', message: maxLengthValidatorMessage },
        { name: 'maxSelectFile', message: maxSelectFileValidatorMessage },
        { name: 'minSizeFile', message: minSizeFileValidatorMessage },
        { name: 'maxSizeFile', message: maxSizeFileValidatorMessage },
        { name: 'min', message: minValidatorMessage },
        { name: 'minLength', message: minLengthValidatorMessage },
        { name: 'name', message: nameValidatorMessage },
        { name: 'nric', message: nricValidatorMessage },
        { name: 'uniqueNricInArray', message: uniqueNricInArrayValidatorMessage },
        { name: 'required', message: requiredValidatorMessage },
        { name: 'requiredTrue', message: requiredTrueValidatorMessage },
        { name: 'requiredSelected', message: requiredTrueValidatorMessage },
        { name: 'tin', message: tinValidatorMessage },
        { name: 'uen', message: uenValidatorMessage },
        { name: 'dateRange', message: dateRangeValidatorMessage },
        { name: 'percentage', message: percentageMessage },
        { name: 'range', message: rangeMessage },
      ],
      validators: [
        { name: 'decimal', validation: decimalValidator },
        { name: 'email', validation: emailValidator },
        { name: 'fileName', validation: fileNameValidator },
        { name: 'maxSelectFile', validation: maxSelectFileValidator },
        { name: 'minSizeFile', validation: minSizeFileValidator },
        { name: 'maxSizeFile', validation: maxSizeFileValidator },
        { name: 'name', validation: nameValidator },
        { name: 'nric', validation: nricValidator },
        { name: 'uniqueNricInArray', validation: uniqueNricInArrayValidator },
        { name: 'requiredFile', validation: requiredFileValidator },
        { name: 'requiredTrue', validation: requiredTrueValidator },
        { name: 'requiredSelected', validation: requiredSelectedValidator },
        { name: 'tin', validation: tinValidator },
        { name: 'uen', validation: uenValidator },
        { name: 'dateRange', validation: dateRangeValidator },
        { name: 'percentage', validation: percentageValidator },
        { name: 'range', validation: rangeValidator },
      ],
    }),
  ],
})
export class PortalFormValidationModule {}
